import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import _get from 'lodash/get'
import _startsWith from 'lodash/startsWith'
import { getBoundActions } from '../../actions/index'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_BUTTON } from '../ButtonSignUp/index'
import GaiaLogo, { TYPE_BLUE_DARK } from '../GaiaLogo/GaiaLogo'
import { connect as connectStaticText } from '../StaticText/connect'
import { getPrimary } from '../../services/languages/index'
import { get as getConfig } from '../../config/index'
import { EN } from '../../services/languages/constants'
import {
  complianceCategoryInActiveGroups,
  COMPLIANCE_MANAGEMENT_CAGETORY_TARGETING,
} from '../../services/compliance-management/index'
import {
  isLogout,
  isLogin,
  isAnonymousHome,
  isGetStarted,
  isCart,
  isPlans,
  isFullPlayer,
  isPasswordReset,
  isGo,
  isPolicy,
  isActivate,
  isSharePage,
  isPlanSelectionPlans,
  isMyAccountPage,
  isLivePage,
  isLiveEvents,
  isLiveChannelPage,
  isEmailSettings,
  isGift as isGiftPage,
  isRemoteAccountCreate,
  isSinglePageCheckout,
  isLoginWithLink,
} from '../../services/url/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import { CUSTOM_EVENT_GA4_EVENT } from '../../services/event-tracking/index'

const config = getConfig()
// this is for the OneTrust cookie banner
const oneTrustEnabled = !!_get(config, ['features', 'oneTrust'])

function onClickCta (
  e,
  setPopupMarketingPromoCookiePersistent,
  setPopupMarketingPromoVisible,
  setPopupMarketingPromoSuccess,
  uid,
  authToken,
  setCookieAllowed,
) {
  e.stopPropagation()
  setPopupMarketingPromoCookiePersistent(1, uid, authToken, setCookieAllowed)
  setPopupMarketingPromoVisible(false)
  setPopupMarketingPromoSuccess(true)
}

function onClickClose (
  e,
  setPopupMarketingPromoCookiePersistent,
  setPopupMarketingPromoVisible,
  setPopupMarketingPromoSuccess,
  uid,
  authToken,
  setCookieAllowed,
) {
  e.stopPropagation()
  setPopupMarketingPromoCookiePersistent(1, uid, authToken, setCookieAllowed)
  setPopupMarketingPromoVisible(false)
  setPopupMarketingPromoSuccess(false)
}

function shouldRender (
  isAuthenticated,
  promoCookie,
  location,
  activeDialog,
) {
  if (
    isAuthenticated
    || promoCookie
    || isSharePage(location.pathname)
    || isLogout(location.pathname)
    || isLogin(location.pathname)
    || isGetStarted(location.pathname)
    || isCart(location.pathname)
    || isPlans(location.pathname)
    || isFullPlayer(location.query)
    || isGo(location.pathname)
    || isPasswordReset(location.pathname)
    || isAnonymousHome(location.pathname, isAuthenticated)
    || isPolicy(location.pathname)
    || isActivate(location.pathname)
    || isPlanSelectionPlans(location.pathname)
    || isMyAccountPage(location.pathname)
    || isLivePage(location.pathname)
    || isLiveEvents(location.pathname)
    || isLiveChannelPage(location.pathname)
    || isEmailSettings(location.pathname)
    || isGiftPage(location.pathname)
    || isRemoteAccountCreate(location.pathname)
    || isRemoteAccountCreate(location.pathname)
    || isLoginWithLink(location.pathname)
    || activeDialog
    || _startsWith(location.pathname, '/invite/join')
    || isSinglePageCheckout(location.pathname) // Single Page Checkout
  ) {
    return false
  }
  return true
}

function getIconClass (userLanguage) {
  const className = 'popup-marketing-promo__right-icon'
  return `${className} ${className}--${userLanguage}`
}

function getLeftPriceClass (userLanguage) {
  const prefix = 'popup-marketing-promo__left-price'
  const className = ['popup-marketing-promo__left-price', `${prefix}--${userLanguage}`]
  return className.join(' ')
}

function getRightMessageClass (userLanguage, type) {
  const prefix = 'popup-marketing-promo__right-message'
  const className = ['popup-marketing-promo__right-message', `${prefix}--${type}-${userLanguage}`]
  return className.join(' ')
}

class PopupMarketingPromo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      processing: false,
    }
  }

  componentDidMount () {
    const { props } = this
    const {
      popupMarketingPromo,
      getPopupMarketingPromoCookiePersistent,
    } = props
    if (!popupMarketingPromo.get('cookie')) {
      // initialize the cookie value in the store
      getPopupMarketingPromoCookiePersistent()
    }
  }

  componentDidUpdate (prevProps) {
    if (process.env.BROWSER) {
      const { props: nextProps } = this
      const { auth, timer, setEventDefault } = nextProps
      const promoCookie = nextProps.popupMarketingPromo.get('cookie')
      const activeDialog = nextProps.dialog.get('componentName', null)
      const popupVisible = nextProps.popupMarketingPromo.get('visible')
      const isAuthenticated = auth.get('jwt') ? true : false  // eslint-disable-line
      const popupShouldRender = shouldRender(
        isAuthenticated,
        promoCookie,
        nextProps.location,
        activeDialog,
      )

      // If we are changing urls and shouldn't render the popup
      // mainly for the browser back/forward button
      if (
        prevProps.location.pathname !== nextProps.location.pathname
        && !popupShouldRender
      ) {
        clearTimeout(this._setPopupTimeout)
        this.setState(() => ({ processing: false })) // eslint-disable-line
        if (popupVisible) {
          nextProps.setPopupMarketingPromoVisible(false)
        }
      } else
        if (!prevProps.dialog.get('componentName', null) && nextProps.dialog.get('componentName', null)) {
        // If we are transitioning from not having a dialog to having one
          clearTimeout(this._setPopupTimeout)
        this.setState(() => ({ processing: false })) // eslint-disable-line
          if (popupVisible) {
            nextProps.setPopupMarketingPromoVisible(false)
          }
        } else if (this.state.processing !== true && popupShouldRender) {
        // if we haven't alread set processing state and the popup should render
        this.setState(() => ({ processing: true })) // eslint-disable-line
          this._setPopupTimeout = setTimeout(() => {
            nextProps.setPopupMarketingPromoVisible(true)
            // GA4 event
            setEventDefault(CUSTOM_EVENT_GA4_EVENT.mergeDeep({
              event_category: 'Pop up',
              event_action: 'Displayed',
              event_label: 'sign-up-popup',
            }))
          }, timer)
        }
    }
  }

  componentWillUnmount () {
    if (process.env.BROWSER) {
      const { props } = this
      const { setPopupMarketingPromoVisible } = props
      setPopupMarketingPromoVisible(false)
      clearTimeout(this._setPopupTimeout)
    }
  }

  render () {
    const { props } = this
    const {
      location,
      popupMarketingPromo,
      dialog,
      setPopupMarketingPromoCookiePersistent,
      setPopupMarketingPromoVisible,
      setPopupMarketingPromoSuccess,
      auth,
      staticText,
      userLanguage,
      complianceManagementGroups,
      setEventDefault,
    } = props
    const promoCookie = popupMarketingPromo.get('cookie')
    const popupVisible = popupMarketingPromo.get('visible')
    const activeDialog = dialog.get('componentName', null)
    const authToken = auth.get('jwt')
    const uid = auth.get('uid')
    const isAuthenticated = authToken ? true : false  // eslint-disable-line
    const popupShouldRender = shouldRender(
      isAuthenticated,
      promoCookie,
      location,
      activeDialog,
    )
    const userPrimaryLanguage = getPrimary(userLanguage)
    const userLanguageIsEn = userPrimaryLanguage === EN
    const inTargetingCagetory = complianceCategoryInActiveGroups(
      complianceManagementGroups,
      COMPLIANCE_MANAGEMENT_CAGETORY_TARGETING,
    )
    let setCookieAllowed = true

    if (oneTrustEnabled && !inTargetingCagetory) {
      setCookieAllowed = false
    }

    function closeClick (e) {
      // GA4 event
      setEventDefault(CUSTOM_EVENT_GA4_EVENT.mergeDeep({
        event_category: 'Pop Up',
        event_action: 'Exit Click',
        event_label: 'sign-up-popup',
      }))

      onClickClose(
        e,
        setPopupMarketingPromoCookiePersistent,
        setPopupMarketingPromoVisible,
        setPopupMarketingPromoSuccess,
        uid,
        authToken,
        setCookieAllowed,
      )
    }

    function ctaClick (e) {
      // GA4 event
      setEventDefault(CUSTOM_EVENT_GA4_EVENT.mergeDeep({
        event_category: 'Pop Up',
        event_action: 'CTA Click',
        event_label: 'sign-up-popup',
      }))

      onClickCta(
        e,
        setPopupMarketingPromoCookiePersistent,
        setPopupMarketingPromoVisible,
        setPopupMarketingPromoSuccess,
        uid,
        authToken,
        setCookieAllowed,
      )
    }

    if (popupShouldRender && popupVisible) {
      return (
        <div className="popup-marketing-promo">
          <div className="popup-marketing-promo__content">
            <span
              className="popup-marketing-promo__close"
              onClick={(e) => closeClick(e)}
            >
              <IconV2
                className="popup-marketing-promo__close-icon"
                type={ICON_TYPES.CLOSE}
              />
            </span>
            <div className="popup-marketing-promo__left">
              <GaiaLogo
                type={TYPE_BLUE_DARK}
                className={['popup-marketing-promo__left-logo']}
              />
              <div className="popup-marketing-promo__left-message">{staticText.getIn(['data', 'description'])}</div>
              <div className={getLeftPriceClass(userPrimaryLanguage)}>
                {staticText.getIn(['data', 'free'])}
              </div>
              <div className={!userLanguageIsEn ? 'popup-marketing-promo__left-qualifier popup-marketing-promo__left-qualifier--non-en' : 'popup-marketing-promo__left-qualifier'}>
                {staticText.getIn(['data', 'promoPeriodOneWeek'])}
              </div>
              <ButtonSignUp
                type={BUTTON_SIGN_UP_TYPE_BUTTON}
                text={staticText.getIn(['data', 'startTrial'])}
                buttonClass={['button--primary', !userLanguageIsEn ? 'popup-marketing-promo__cta-link popup-marketing-promo__cta-link--non-en' : 'popup-marketing-promo__cta-link']}
                onClick={(e) => ctaClick(e)}
              />
            </div>
            <div className="popup-marketing-promo__right">
              <ul className="popup-marketing-promo__message-list">
                <li className="popup-marketing-promo__message-item">
                  <IconV2
                    className={getIconClass(userPrimaryLanguage)}
                    type={ICON_TYPES.CHECK}
                  />
                  <div className={getRightMessageClass(userPrimaryLanguage, 'cancel')}>{staticText.getIn(['data', 'cancelAnytime'])}</div>
                </li>
                <li className="popup-marketing-promo__message-item">
                  <IconV2
                    className={getIconClass(userPrimaryLanguage)}
                    type={ICON_TYPES.CHECK}
                  />
                  <div className={getRightMessageClass(userPrimaryLanguage, 'stream')}>{staticText.getIn(['data', 'stream'])}</div>
                </li>
                <li className="popup-marketing-promo__message-item">
                  <IconV2
                    className={getIconClass(userPrimaryLanguage)}
                    type={ICON_TYPES.CHECK}
                  />
                  <div className={getRightMessageClass(userPrimaryLanguage, 'unlimited')}>{staticText.getIn(['data', 'unlimitedStreaming'])}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )
    }
    return null
  }
}

PopupMarketingPromo.propTypes = {
  location: PropTypes.object.isRequired,
  timer: PropTypes.number.isRequired,
  popupMarketingPromo: ImmutablePropTypes.map.isRequired,
  dialog: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  setPopupMarketingPromoVisible: PropTypes.func.isRequired,
  setPopupMarketingPromoCookiePersistent: PropTypes.func.isRequired,
  getPopupMarketingPromoCookiePersistent: PropTypes.func.isRequired,
  setPopupMarketingPromoSuccess: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  userLanguage: ImmutablePropTypes.list.isRequired,
  complianceManagementGroups: ImmutablePropTypes.list.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'popupMarketingPromo' }),
  connectRedux(
    (state) => ({
      popupMarketingPromo: state.popupMarketingPromo,
      dialog: state.dialog,
      auth: state.auth,
      userLanguage: state.user.getIn(['data', 'language']),
      complianceManagementGroups: state.complianceManagement.get('groups', List()),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setPopupMarketingPromoVisible:
          actions.popupMarketingPromo.setPopupMarketingPromoVisible,
        setPopupMarketingPromoCookiePersistent:
          actions.popupMarketingPromo.setPopupMarketingPromoCookiePersistent,
        getPopupMarketingPromoCookiePersistent:
          actions.popupMarketingPromo.getPopupMarketingPromoCookiePersistent,
        setPopupMarketingPromoSuccess:
          actions.popupMarketingPromo.setPopupMarketingPromoSuccess,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(PopupMarketingPromo)
